<div class="plot-container">
    <div
        class="canvas-wrapper"
        (mousedown)="eventHandler($event)"
        (mousemove)="eventHandler($event)"
        (mouseup)="eventHandler($event)"
        (mousecancel)="eventHandler($event)"
        (touchstart)="eventHandler($event)"
        (touchmove)="eventHandler($event)"
        (touchend)="eventHandler($event)"
        (touchcancel)="eventHandler($event)"
        (wheel)="eventHandler($event)"
    >
        <div class="in-plot-controls">
            <cds-button action="flat" (click)="resetCamera()">reset camera</cds-button>
        </div>
        <canvas #plotCanvas class="plot" (mousedown)="preventDefault($event)"></canvas>
    </div>
    <svg class="axes">
        <g #xAxis></g>
        <g #yAxis></g>
        <g #colorAxis visibility="hidden"></g>
    </svg>

    <ng-container *ngIf="isLoadingData$ | async">
        <div class="default-loading-indicator overlay">
            <cds-progress-circle></cds-progress-circle>
        </div>
    </ng-container>
</div>
